import { useQuery } from '@tanstack/react-query';

import { useApi } from '@/context';

export const usageKeys = {
    all: ['usage'] as const,
    detail: (tenantId: string) => [...usageKeys.all, tenantId] as const,
};

export function useUsage(tenantId: string | undefined) {
    const api = useApi();

    return useQuery({
        queryKey: usageKeys.detail(tenantId!),
        queryFn: () => api.usage.getUsage(tenantId!),
        enabled: !!tenantId,
    });
}
